<template>
  <el-dialog
    title="添加合同"
    :visible.sync="visible"
    label-width="100px"
    width="40%"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="合同编号" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="合同文件" prop="url">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :limit="1"
          accept=".doc, .docx, .pdf, .xls, .xlsx"
          :headers="uploadHeader"
          :file-list="fileList"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传.doc,.docx,.pdf文件，且不超过10M
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { urlPerfix } from '@/config/env'
import { createContract } from '@/service/getData'
import store from '@/store/store'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  created() {},
  data() {
    return {
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请输入合同编号', trigger: 'blur' }],
        url: [{ required: true, message: '请选择合同文件', trigger: 'blur' }],
      },
      fileList: [],
    }
  },
  methods: {
    handleSuccess(res, file) {
      if (res.code == 0) {
        this.model.url = res.data
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.file}MB!`)
      }
      return isLimitSize
    },
    handleRemove() {
      this.model.url = null
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await createContract(this.model)
          if (res.code == 0) {
            this.$emit('created', res.data)
            this.visible = false
          }
        }
      })
    },
  },
}
</script>
<style>
.avatar-uploader img {
  width: 60px;
  border-radius: 50%;
}
</style>